function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Support({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.738 2c1.104 0 2 .897 2 2v2.096h1.922a1 1 0 011 1v5.934c.01.04.107 1.306-.806 2.315-.518.57-1.227.924-2.115 1.053V19c0 1.103-.898 2-2 2l-2.883.001a2.003 2.003 0 01-1.964 1.624h-3c-1.103 0-2-.897-2-2v-.5c0-1.103.897-2 2-2h3a2 2 0 011.653.875h3.193V6.828h-14v10.568h2.396a1 1 0 110 2H3.739a1 1 0 01-1-1v-2.029c-.8-.15-1.446-.492-1.926-1.023-.83-.917-.826-2.046-.808-2.348l.005-.066-.004-5.833a1 1 0 011-1h1.733V4c0-1.103.897-2 2-2h14zm-4.846 18.125h-3v.5h3v-.5zm2.879-5.382a1 1 0 01-.619 1.27c-.039.014-.373.129-.867.274l-.315.091c-.885.25-2.112.544-3.126.597v.009l-.31-.01c-1.775-.092-4.2-.923-4.308-.96a1 1 0 11.653-1.89c.665.229 2.59.809 3.81.857 1.219-.048 3.145-.628 3.81-.857a1 1 0 011.272.619zm4.89-6.646h-.923l.002 6.263c.266-.073.474-.189.62-.346.259-.277.3-.657.304-.82v-.07-.01l-.004-5.018zm-18.923 0h-.732v4.933c-.004.09-.037.623.299.984.11.118.255.213.433.284V8.096zm5.835.468a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm6.331 0a1.5 1.5 0 11-.001 3.001 1.5 1.5 0 01.001-3.001zM18.738 4h-14v.828h14V4z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

const MemoSupport = React.memo(Support);
export default MemoSupport;